import { get } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { scriptTypes } from 'constants/scripts';
import { getActiveScript, getActiveScriptType, usingLiquidIsChecked, getActiveProducts } from 'current/selectors';
import {
  canSaveScript,
  getScriptTypeForScript
} from 'scripts/selectors';
import {
  hasFertilizerApplicationsForZones
} from 'scripts/zones/fertility-selectors';

/** Selectors for current/uiwidgets state.

    TODO: Move uiwidgets selectors from current/selectors to here. */

export const getCropSelectionDoesNotMeetModal = (state) => state.uiwidgets.cropSelectionDoesNotMeetModal;
export const shouldShowLiquidApplication = (state) => {
  const scriptType = getActiveScriptType(state);
  const { zones } = getActiveScript(state);
  return scriptType === scriptTypes.PLANTING
    && (hasFertilizerApplicationsForZones(zones) || usingLiquidIsChecked(state));
};
export const getLayerInclusionModal = (state) => get(state, 'uiwidgets.layerInclusionModal');
export const getMinimumRequirementsErrorModal = (state) => get(state, 'uiwidgets.minimumRequirementsErrorModal');

const _isKeyLocked = (state, key) => !!get(state, `uiwidgets.locks.${key}`);
export const isPlantingPlanLocked = (state) => _isKeyLocked(state, 'plantingPlan');
export const isSaveTriggerLocked = (state) => _isKeyLocked(state, 'saveTrigger');

export const hasProductSelected = state => {
  const activeProducts = getActiveProducts(state);
  if (activeProducts !== undefined) {
    return activeProducts.length > 0;
  }else{
    return false;
  }
};

export const isPlantingScript = createSelector([
  getActiveScriptType,
  getActiveScript
],
(activeScriptType, activeScript) => {
  const scriptType = activeScript ? getScriptTypeForScript(activeScript) : activeScriptType;
  return scriptType === scriptTypes.PLANTING;
});


export const isSaveTriggerEnabled = (state, script) =>
  canSaveScript(state, script) && !isSaveTriggerLocked(state) && (isPlantingScript(state) || hasProductSelected(state));

export const getEditScriptExitButtonBehavior = (state) => state.uiwidgets.editScriptExitButton;
export const getOptionSelected = (state) => state.uiwidgets.preferredDeviceModal?.optionSelected;
